import { queryOptions } from "@tanstack/react-query";
import { $getPipelineStats } from "./functions";

export const pipelineStatsQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "pipeline"],
    queryFn: ({ signal }) => $getPipelineStats({ signal, data: { projectId } }),
    staleTime: 0, // Always refetch for up-to-date stats
  });
